<template>
  <section
    v-if="itemid"
    :class="headerClasses"
    class="header-region"
  >
    <div
      :class="{ 'content-gradient': hasImage }"
      class="header-content-position"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="header-content">
              <div class="header-leadline">
                <h3>{{ headerLeadline }}</h3>
              </div>
              <div class="header-title"><h1>{{ title }}</h1></div>
              <template v-if="item">
                <div
                  v-if="headerDescription"
                  class="header-description"
                  v-html="headerDescription"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AImage
      v-if="hasImage"
      :img="headerImage"
      responsive
      preset="banner"
    />
  </section>
</template>

<script>

export default {
  name: 'sp-feature-header',
  props: {
    item: {
      type: Object,
      required: true
    },
    headerPosition: {
      type: String,
      required: false,
      default: 'text-center'
    }
  },
  asyncData({ store }) {
    store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
  },
  mounted() {
    this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
  },
  computed: {
    itemid() { return this.item.nid },
    title() { return this.item.title },
    headerDescription() {
      return this.item.field_t_sp_feat_head_description
    },
    headerLeadline() {
      return this.item.field_t_sp_feat_head_leadline
    },
    headerImage() {
      return this.item.field_f_sp_feat_head_image
    },
    headerClasses() {
      return this.headerPosition + ' ' + ((this.hasImage) ? 'has-image' : '')
    },
    headerImageUrl() {
      return 'url("' + this.$options.filters.toUrl(this.headerImage) +'")'
    },
    hasImage() {
      return (this.item.field_f_sp_feat_head_image && this.item.field_f_sp_feat_head_image.filepath)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

//move themeing away from this file

//no image background styling
$header-region-background: #555555 !default;
$header-region-text: $white !default;

//image background styling
$header-region-background-has-image: $dark !default;
$header-region-background-has-image-text: $white !default;

///button
$header-region-link-background: $secondary !default;
$header-region-link-text: $white !default;

// standard followup header regions
.header-region {
  background-color: $header-region-background;
  background: var(--main-page-header-banner-background);
  position: relative;
  margin-bottom:3em;

  .header-content-position {
    width: 100%;
    bottom: 0em;
    padding-top: calc(var(--main-page-header-banner-padding) *3.5);
    padding-bottom: calc(var(--main-page-header-banner-padding) *.5);
    @include media-breakpoint-up(sm) {
      padding-top: calc(var(--main-page-header-banner-padding) *3.5);
      padding-bottom: calc(var(--main-page-header-banner-padding) * .75);
    }
    @include media-breakpoint-up(lg) {
      padding-top: calc(var(--main-page-header-banner-padding) * 3.5);
      padding-bottom: calc(var(--main-page-header-banner-padding) * 1);
    }
  }
  .header-content {
    color: $header-region-text;
  }
  .header-description {
    font-size: 1.2em;
  }
}
.header-background {
  // @include bg-cover (50% 25%);
  position: absolute;
}

.text-center {
  a.btn {
    margin: 0em 0.5em;
  }
}
.header-links {
  a.btn {
    box-shadow: none;
    padding: 1em 1.25em;
    background-color: $header-region-link-background;
    color: $header-region-link-text;
    @if $enable-rounded {
      border-radius: $border-radius-lg;
    }
  }
}
//if header hasImage
.has-image {
  background-color: $header-region-background-has-image;
  background: var(--main-page-header-banner-background);

  .header-content-position {
    padding-top: calc(var(--main-page-header-banner-padding) *4);
    padding-bottom: calc(var(--main-page-header-banner-padding) *.5);
    @include media-breakpoint-up(sm) {
      padding-top: calc(var(--main-page-header-banner-padding) *4);
      padding-bottom: calc(var(--main-page-header-banner-padding) * .75);
    }
    @include media-breakpoint-up(lg) {
      padding-top: calc(var(--main-page-header-banner-padding) * 5);
      padding-bottom: calc(var(--main-page-header-banner-padding) * 1);
    }
  }
  .header-content {
    color: $header-region-background-has-image-text;
  }

  .header-description {
    opacity: 0.8;
  }
}

//class applied if header hasImage
.content-gradient {
  bottom: 0;
  left: 0;
  width: 100%;
  position: relative;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.05) 80%, transparent);
}

.image-background {
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: 50%;
}

.header-region {
  &.has-image {
    ::v-deep .a-image {
      position: absolute;
      top: 0;
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .header-content-position {
      bottom: 0;
      z-index: 2;
    }
  }
}
</style>
